export default {
  en: {
    "setup.label.group_ticketing": "Group Ticketing",
    "sidebar.label.makerCheckerAction": "Maker Checker Action",
    "sidebar.label.order_management": "Order Management",
    "sidebar.label.dashboard": "Dashboard",
    "sidebar.label.customers": "Customers",
    "sidebar.label.inventory": "Inventory",
    "sidebar.label.tickets": "Tickets",
    "sidebar.label.business_entity": "Business Entity",
    "sidebar.label.leads": "Leads",
    "sidebar.label.system": "System",
    "sidebar.label.users": "Users",
    "reports.label.manageRolesAndPermissions": "Manage Roles And Permissions",
    "reports.label.currencyMaster": "Currency Master",
    "reports.label.currencyExchangeRates": "Currency Exchange Rates",
    "reports.label.configurations": "Configurations",
    "reports.label.provisioningConfiguration": "Provisioning Configuration",
    "reports.label.manageReports": "Manage Reports",
    "reports.label.manageCodes": "Manage Codes",
    "sidebar.label.setup": "Setup",
    "sidebar.label.reports": "Reports",
    "sidebar.label.admin": "Admin",
    "sidebar.label.bulk_uploads": "Bulk Uploads",
    "sidebar.label.scheduler_job": "Scheduler Job",
    "sidebar.label.online_payments": "Online Payments",
    "sidebar.label.payment_transactions": "Payment Transactions",
    "sidebar.label.provisioning_status": "Provisioning Status",
    "sidebar.label.hooks": "Hooks (Event Action)",
    "sidebar.label.maker_checker": "Maker Checker",
    "sidebar.label.command_center": "Command Center",
    "sidebar.label.accounting": "Accounting",
    "sidebar.label.search_journal_entries": "Search Journal Entries",
    "sidebar.label.migrate_opening_balances": "Migrate Opening Balances",
    "sidebar.label.no_generator": "No Generator",
    "sidebar.label.assets": "Assets",
    "sidebar.label.general": "General",
    "sidebar.label.ticketing": "Ticketing",
    "sidebar.label.plan_validation_rules": "Plan Validation Rules",
    "sidebar.label.sub_products": "Sub Products",
    "sidebar.label.plan_prereqisites": "Plan Pre-Reqisites",
    "sidebar.label.subscription_master": "Subscription Master",
    "sidebar.label.plan_management": "Plan Management",
    "sidebar.label.billingManagement": "Billing Management",
    "sidebar.label.plan": "Plan",
  },

  fr: {
    "setup.label.group_ticketing": "Billetterie de groupe",
    "sidebar.label.payment_transactions": "Transactions de paiement",
    "sidebar.label.makerCheckerAction": "Action de vérification du fabricant",
    "sidebar.label.order_management": "Gestion des commandes",
    "sidebar.label.dashboard": "Tableau de bord",
    "sidebar.label.customers": "Clients",
    "sidebar.label.inventory": "Inventaire",
    "sidebar.label.tickets": "Tickets",
    "sidebar.label.business_entity": "Entité commerciale",
    "sidebar.label.leads": "Pistes",
    "sidebar.label.system": "Système",
    "sidebar.label.users": "Utilisateurs",
    "reports.label.manageRolesAndPermissions":
      "Gérer les rôles et les autorisations",
    "reports.label.currencyMaster": "Maître de la devise",
    "reports.label.currencyExchangeRates": "Taux de change des devises",
    "reports.label.configurations": "Configurations",
    "reports.label.provisioningConfiguration":
      "Configuration de provisionnement",
    "reports.label.manageReports": "Gérer les rapports",
    "reports.label.manageCodes": "Gérer les codes",
    "sidebar.label.setup": "Configuration",
    "sidebar.label.reports": "Rapports",
    "sidebar.label.admin": "Admin",
    "sidebar.label.bulk_uploads": "Téléchargements en masse",
    "sidebar.label.scheduler_job": "Tâche planifiée",
    "sidebar.label.online_payments": "Paiements en ligne",
    "sidebar.label.provisioning_status": "Statut de provisionnement",
    "sidebar.label.hooks": "Crochets (Action d'événement)",
    "sidebar.label.maker_checker": "Vérificateur de fabricant",
    "sidebar.label.command_center": "Centre de Commande",
    "sidebar.label.accounting": "Comptabilité",
    "sidebar.label.search_journal_entries": "Rechercher des Entrées de Journal",
    "sidebar.label.migrate_opening_balances": "Migrer les Soldes d'Ouverture",
    "sidebar.label.no_generator": "Pas de Générateur",
    "sidebar.label.assets": "Actifs",
    "sidebar.label.general": "Général",
    "sidebar.label.ticketing": "Billetterie",
    "sidebar.label.plan_validation_rules": "Règles de Validation des Plans",
    "sidebar.label.sub_products": "Sous-Produits",
    "sidebar.label.plan_prereqisites": "Prérequis du Plan",
    "sidebar.label.subscription_master": "Master des Abonnements",
  },

  es: {
    "setup.label.group_ticketing": "Billeteo de grupo",
    "sidebar.label.payment_transactions": "Transacciones de pago",
    "sidebar.label.makerCheckerAction": "Acción de verificación del fabricante",
    "sidebar.label.order_management": "Gestión de pedidos",
    "sidebar.label.dashboard": "Tablero",
    "sidebar.label.customers": "Clientes",
    "sidebar.label.inventory": "Inventario",
    "sidebar.label.tickets": "Tickets",
    "sidebar.label.business_entity": "Entidad comercial",
    "sidebar.label.leads": "Clientes potenciales",
    "sidebar.label.system": "Sistema",
    "sidebar.label.users": "Usuarios",
    "reports.label.manageRolesAndPermissions": "Gestionar roles y permisos",
    "reports.label.currencyMaster": "Maestro de divisas",
    "reports.label.currencyExchangeRates": "Tipos de cambio de divisas",
    "reports.label.configurations": "Configuraciones",
    "reports.label.provisioningConfiguration":
      "Configuración de aprovisionamiento",
    "reports.label.manageReports": "Gestionar informes",
    "reports.label.manageCodes": "Gestionar códigos",
    "sidebar.label.setup": "Configuración",
    "sidebar.label.reports": "Informes",
    "sidebar.label.admin": "Admin",
    "sidebar.label.bulk_uploads": "Cargas masivas",
    "sidebar.label.scheduler_job": "Trabajo programado",
    "sidebar.label.online_payments": "Pagos en línea",
    "sidebar.label.provisioning_status": "Estado de aprovisionamiento",
    "sidebar.label.hooks": "Ganchos (Acción de evento)",
    "sidebar.label.maker_checker": "Comprobador de fabricante",
    "sidebar.label.command_center": "Centro de Comando",
    "sidebar.label.accounting": "Contabilidad",
    "sidebar.label.search_journal_entries": "Buscar Entradas del Diario",
    "sidebar.label.migrate_opening_balances": "Migrar Saldos Iniciales",
    "sidebar.label.no_generator": "Sin Generador",
    "sidebar.label.assets": "Activos",
    "sidebar.label.general": "General",
    "sidebar.label.ticketing": "Sistemas de Tickets",
    "sidebar.label.plan_validation_rules": "Reglas de Validación del Plan",
    "sidebar.label.sub_products": "Subproductos",
    "sidebar.label.plan_prereqisites": "Requisitos Previos del Plan",
    "sidebar.label.subscription_master": "Maestro de Suscripciones",
  },

  pt: {
    "setup.label.group_ticketing": "Bilhetagem de grupo",
    "sidebar.label.payment_transactions": "Transações de pagamento",
    "sidebar.label.makerCheckerAction": "Ação de verificação do fabricante",
    "sidebar.label.order_management": "Gestão de pedidos",
    "sidebar.label.dashboard": "Painel de controle",
    "sidebar.label.customers": "Clientes",
    "sidebar.label.inventory": "Inventário",
    "sidebar.label.tickets": "Bilhetes",
    "sidebar.label.business_entity": "Entidade comercial",
    "sidebar.label.leads": "Leads",
    "sidebar.label.system": "Sistema",
    "sidebar.label.users": "Usuários",
    "reports.label.manageRolesAndPermissions": "Gerenciar funções e permissões",
    "reports.label.currencyMaster": "Mestre de moeda",
    "reports.label.currencyExchangeRates": "Taxas de câmbio de moeda",
    "reports.label.configurations": "Configurações",
    "reports.label.provisioningConfiguration":
      "Configuração de provisionamento",
    "reports.label.manageReports": "Gerenciar relatórios",
    "reports.label.manageCodes": "Gerenciar códigos",
    "sidebar.label.setup": "Configuração",
    "sidebar.label.reports": "Relatórios",
    "sidebar.label.admin": "Admin",
    "sidebar.label.bulk_uploads": "Envios em massa",
    "sidebar.label.scheduler_job": "Trabalho de agendamento",
    "sidebar.label.online_payments": "Pagamentos online",
    "sidebar.label.provisioning_status": "Status de provisionamento",
    "sidebar.label.hooks": "Hooks (Ação de evento)",
    "sidebar.label.maker_checker": "Verificador do Criador",
    "sidebar.label.command_center": "Central de Comando",
    "sidebar.label.accounting": "Contabilidade",
    "sidebar.label.search_journal_entries": "Pesquisar Lançamentos Contábeis",
    "sidebar.label.migrate_opening_balances": "Migrar Saldos Iniciais",
    "sidebar.label.no_generator": "Sem Gerador",
    "sidebar.label.assets": "Ativos",
    "sidebar.label.general": "Geral",
    "sidebar.label.ticketing": "Sistema de Chamados",
    "sidebar.label.plan_validation_rules": "Regras de Validação do Plano",
    "sidebar.label.sub_products": "Subprodutos",
    "sidebar.label.plan_prereqisites": "Pré-requisitos do Plano",
    "sidebar.label.subscription_master": "Mestre de Assinaturas",
  },

  zh_CN: {
    "setup.label.group_ticketing": "团体票务",
    "sidebar.label.payment_transactions": "付款交易",
    "sidebar.label.makerCheckerAction": "制造商检查员行动",
    "sidebar.label.order_management": "订单管理",
    "sidebar.label.dashboard": "仪表板",
    "sidebar.label.customers": "客户",
    "sidebar.label.inventory": "库存",
    "sidebar.label.tickets": "工单",
    "sidebar.label.business_entity": "商业实体",
    "sidebar.label.leads": "潜在客户",
    "sidebar.label.system": "系统",
    "sidebar.label.users": "用户",
    "reports.label.manageRolesAndPermissions": "管理角色和权限",
    "reports.label.currencyMaster": "货币主数据",
    "reports.label.currencyExchangeRates": "货币汇率",
    "reports.label.configurations": "配置",
    "reports.label.provisioningConfiguration": "配置配置",
    "reports.label.manageReports": "管理报告",
    "reports.label.manageCodes": "管理代码",
    "sidebar.label.setup": "设置",
    "sidebar.label.reports": "报告",
    "sidebar.label.admin": "管理员",
    "sidebar.label.bulk_uploads": "批量上传",
    "sidebar.label.scheduler_job": "调度作业",
    "sidebar.label.online_payments": "在线支付",
    "sidebar.label.provisioning_status": "配置状态",
    "sidebar.label.hooks": "钩子（事件操作）",
    "sidebar.label.maker_checker": "製造商檢查器",
    "sidebar.label.command_center": "指挥中心",
    "sidebar.label.accounting": "会计",
    "sidebar.label.search_journal_entries": "搜索凭证条目",
    "sidebar.label.migrate_opening_balances": "迁移期初余额",
    "sidebar.label.no_generator": "无生成器",
    "sidebar.label.assets": "资产",
    "sidebar.label.general": "常规",
    "sidebar.label.ticketing": "工单系统",
    "sidebar.label.plan_validation_rules": "计划验证规则",
    "sidebar.label.sub_products": "子产品",
    "sidebar.label.plan_prereqisites": "计划前提条件",
    "sidebar.label.subscription_master": "订阅主表",
  },

  hi: {
    "setup.label.group_ticketing": "समूह टिकटिंग",
    "sidebar.label.payment_transactions": "भुगतान लेन-देन",
    "sidebar.label.makerCheckerAction": "मेकर चेकर कार्रवाई",
    "sidebar.label.order_management": "आदेश प्रबंधन",
    "sidebar.label.dashboard": "डैशबोर्ड",
    "sidebar.label.customers": "ग्राहक",
    "sidebar.label.inventory": "इन्वेंटरी",
    "sidebar.label.tickets": "टिकट",
    "sidebar.label.business_entity": "व्यवसायिक एंटिटी",
    "sidebar.label.leads": "लीड्स",
    "sidebar.label.system": "सिस्टम",
    "sidebar.label.users": "उपयोगकर्ता",
    "reports.label.manageRolesAndPermissions":
      "भूमिकाएँ और अनुमतियाँ प्रबंधित करें",
    "reports.label.currencyMaster": "मुद्रा मास्टर",
    "reports.label.currencyExchangeRates": "मुद्रा विनिमय दरें",
    "reports.label.configurations": "कॉन्फ़िगरेशन",
    "reports.label.provisioningConfiguration": "प्राविधिक कॉन्फ़िगरेशन",
    "reports.label.manageReports": "रिपोर्ट प्रबंधित करें",
    "reports.label.manageCodes": "कोड प्रबंधित करें",
    "sidebar.label.setup": "सेटअप",
    "sidebar.label.reports": "रिपोर्ट्स",
    "sidebar.label.admin": "व्यवस्थापक",
    "sidebar.label.bulk_uploads": "बल्क अपलोड",
    "sidebar.label.scheduler_job": "शेड्यूलर जॉब",
    "sidebar.label.online_payments": "ऑनलाइन भुगतान",
    "sidebar.label.provisioning_status": "प्रोविजनिंग स्थिति",
    "sidebar.label.hooks": "हुक्स (घटना क्रिया)",
    "sidebar.label.maker_checker": "मेकर चेकर",
    "sidebar.label.command_center": "कमांड सेंटर",
    "sidebar.label.accounting": "लेखांकन",
    "sidebar.label.search_journal_entries": "जर्नल प्रविष्टियाँ खोजें",
    "sidebar.label.migrate_opening_balances": "ओपनिंग बैलेंस माइग्रेट करें",
    "sidebar.label.no_generator": "कोई जनरेटर नहीं",
    "sidebar.label.assets": "संपत्ति",
    "sidebar.label.general": "सामान्य",
    "sidebar.label.ticketing": "टिकटिंग",
    "sidebar.label.plan_validation_rules": "योजना सत्यापन नियम",
    "sidebar.label.sub_products": "उप उत्पाद",
    "sidebar.label.plan_prereqisites": "योजना पूर्व शर्तें",
    "sidebar.label.subscription_master": "सब्सक्रिप्शन मास्टर",
  },

  ka: {
    "setup.label.group_ticketing": "ჯგუფური ბილეთები",
    "sidebar.label.payment_transactions": "გადახდების ტრანზაქციები",
    "sidebar.label.makerCheckerAction": "მექერი შემოწმე",
    "sidebar.label.order_management": "შეკვეთების მართვა",
    "sidebar.label.dashboard": "საბარათი",
    "sidebar.label.customers": "მომხამრებელი",
    "sidebar.label.inventory": "ინვენტარი",
    "sidebar.label.tickets": "ბილეთები",
    "sidebar.label.business_entity": "ბიზნეს ენთიტი",
    "sidebar.label.leads": "მომწოდებლები",
    "sidebar.label.system": "სისტემა",
    "sidebar.label.users": "მომხმარებლები",
    "reports.label.manageRolesAndPermissions": "როლების და უფლებების მართვა",
    "reports.label.currencyMaster": "ვალუტის მასტერი",
    "reports.label.currencyExchangeRates": "ვალუტის გაცვლითი კურსები",
    "reports.label.configurations": "კონფიგურაციები",
    "reports.label.provisioningConfiguration": "პროვიზიონირების კონფიგურაცია",
    "reports.label.manageReports": "რეპორტების მართვა",
    "reports.label.manageCodes": "კოდების მართვა",
    "sidebar.label.setup": "დაყენება",
    "sidebar.label.reports": "ანგარიშები",
    "sidebar.label.admin": "ადმინი",
    "sidebar.label.bulk_uploads": "მასშტაბი ატვირთვები",
    "sidebar.label.scheduler_job": "გრაფიკის დავალება",
    "sidebar.label.online_payments": "Სარჩევები ინტერნეტში",
    "sidebar.label.provisioning_status": "Დამზადების სტატუსი",
    "sidebar.label.hooks": "Hooks (მოვლენების ქმედება)",
    "sidebar.label.maker_checker": "Maker Checker",
    "sidebar.label.command_center": "ಕಮಾಂಡ್ ಸೆಂಟರ್",
    "sidebar.label.accounting": "ಖಾತಾ ನಿರ್ವಹಣೆ",
    "sidebar.label.search_journal_entries": "ಜರ್ನಲ್ ಎಂಟ್ರಿಗಳನ್ನು ಹುಡುಕು",
    "sidebar.label.migrate_opening_balances": "ಆರಂಭಿಕ ಬಲಾನ್ಸ್ಗಳನ್ನು ವರ್ಗಾಯಿಸು",
    "sidebar.label.no_generator": "ಜನರೆಟರ್ ಇಲ್ಲ",
    "sidebar.label.assets": "ಆಸ್ತಿಗಳು",
    "sidebar.label.general": "ಸಾಮಾನ್ಯ",
    "sidebar.label.ticketing": "ಟಿಕೆಟ್ ವ್ಯವಸ್ಥೆ",
    "sidebar.label.plan_validation_rules": "ಯೋಜನಾ ಪರಿಶೀಲನೆ ನಿಯಮಗಳು",
    "sidebar.label.sub_products": "ಉಪ ಉತ್ಪನ್ನಗಳು",
    "sidebar.label.plan_prereqisites": "ಯೋಜನೆ ಪೂರ್ವ ಶರತ್ತுகள்",
    "sidebar.label.subscription_master": "ಸಬ್‌ಸ್ಕ್ರಿಪ್ಷನ್ ಮಾಸ್ಟರ್",
  },

  lo: {
    "setup.label.group_ticketing": "ການຈັດການບິນກຸ່ມ",
    "sidebar.label.payment_transactions": "ການເອົາເງິນ",
    "sidebar.label.makerCheckerAction": "ການກວດສອບຜູ້ສ້າງ",
    "sidebar.label.order_management": "ການຈັດສົ່ງ",
    "sidebar.label.dashboard": "ກ່ອງຫຼາຍ",
    "sidebar.label.customers": "ລູກຄ້າ",
    "sidebar.label.inventory": "ການຄັດສະຕ໋ອກ",
    "sidebar.label.tickets": "ບິນ",
    "sidebar.label.business_entity": "ຕົວແທນທາງຢືມ",
    "sidebar.label.leads": "ຄົນຊ່ວຍຕັ້ງ",
    "sidebar.label.system": "ລະບົບ",
    "sidebar.label.users": "ຜູ້ໃຊ້ງານ",
    "reports.label.manageRolesAndPermissions": "ຈັດການບົດບາດແລະສິດທິ",
    "reports.label.currencyMaster": "ຕົວແທນເງິນ",
    "reports.label.currencyExchangeRates": "ອັດຕາເງິນ",
    "reports.label.configurations": "ການຕັ້ງຄ່າ",
    "reports.label.provisioningConfiguration": "ການຕັ້ງຄ່າການສະແດງ",
    "reports.label.manageReports": "ຈັດການບົດບາດ",
    "reports.label.manageCodes": "ຈັດການລະຫັດ",
    "sidebar.label.setup": "ການຕັ້ງຄ່າ",
    "sidebar.label.reports": "ບົດລາຍ",
    "sidebar.label.admin": "ບໍລິສັດ",
    "sidebar.label.bulk_uploads": "ການອອກໂຄດ",
    "sidebar.label.scheduler_job": "ວິຊາການຂອງຕາຕະລາງ",
    "sidebar.label.online_payments": "ການຈ່າຍອອກເປັນເງິນການຈ່າຍ",
    "sidebar.label.provisioning_status": "ສະຖານະການບໍລິການ",
    "sidebar.label.hooks": "ຫຸ່ນ (ການປຽບທຽບຂອງການເຮັດວຽກ)",
    "sidebar.label.maker_checker": "ຜູ້ກວດສອບຜູ້ສ້າງ",
    "sidebar.label.command_center": "ສູນຄຳສັ່ງ",
    "sidebar.label.accounting": "ການບັນຊີ",
    "sidebar.label.search_journal_entries": "ຄົ້ນຫາຂຽນບັນທຶກ",
    "sidebar.label.migrate_opening_balances": "ຍ້າຍຍອດສົກການເລີ່ມຕົ້ນ",
    "sidebar.label.no_generator": "ບໍ່ມີເຈັນເລີດ",
    "sidebar.label.assets": "ທຶນສິນ",
    "sidebar.label.general": "ທົ່ວໄປ",
    "sidebar.label.ticketing": "ລະບົບປະຕິເຮືອນ",
    "sidebar.label.plan_validation_rules": "ກົດເຫົາການກວດສອບແຜນ",
    "sidebar.label.sub_products": "ຜະລິດຕະພັນຍ່ອຍ",
    "sidebar.label.plan_prereqisites": "ຄຳກ່ອນເກີນການວາງແຜນ",
    "sidebar.label.subscription_master": "ຫົວຂໍ້ການສົດສົມມິ",
  },

  my_MM: {
    "setup.label.group_ticketing": "အုပ်စုလက်မှတ်များ",
    "sidebar.label.payment_transactions": "ငွေပေးချေမှုများ",
    "sidebar.label.makerCheckerAction": "ဖန်တီးသူ စစ်ဆေးသူ",
    "sidebar.label.order_management": "အမှာစာများကို စီမံခန့်ခွဲမှု",
    "sidebar.label.dashboard": "ဒိုင်စက်စာမျက်နှာ",
    "sidebar.label.customers": "အဖွဲ့ဝင်များ",
    "sidebar.label.inventory": "အရေတွက်",
    "sidebar.label.tickets": "လက်မှတ်များ",
    "sidebar.label.business_entity": "စီးပွားရေးအနီးအနား",
    "sidebar.label.leads": "လွှာတင်ရန်",
    "sidebar.label.system": "စနစ်",
    "sidebar.label.users": "အသုံးပြုသူများ",
    "reports.label.manageRolesAndPermissions":
      "သုံးစွဲခြင်းနှင့် ခွင့်ပြုခြင်း စီမံခန့်ခွဲမှု",
    "reports.label.currencyMaster": "ငွေကြေးစီမံခန့်ခွဲမှု",
    "reports.label.currencyExchangeRates": "ငွေကြေး လွှဲပြောင်းမှု",
    "reports.label.configurations": "တပ်ဆင်များ",
    "reports.label.provisioningConfiguration": "ကုန်လွှဲခန့်ခွဲမှု",
    "reports.label.manageReports": "အစီရင်ခံစာများကုဒ်များ",
    "reports.label.manageCodes": "ကုဒ်များကုဒ်များ",
    "sidebar.label.setup": "ဆက်တင်မည်",
    "sidebar.label.reports": "အစီရင်ခံချက်များ",
    "sidebar.label.admin": "အက်မင်",
    "sidebar.label.bulk_uploads": "ကုန်လက်တင်မည်",
    "sidebar.label.scheduler_job": "အချိန်ဇယားကုမ္ပဏီ",
    "sidebar.label.online_payments": "ငွေပေးချေမှုများ",
    "sidebar.label.provisioning_status": "ပေးဆောင်းမှုအခြေအနေ",
    "sidebar.label.hooks": "ချုပ်များ (အဖွဲ့အစည်းလုံး)",
    "sidebar.label.maker_checker": "ဖန်တီးသူ စစ်ဆေးသူ",
    "sidebar.label.command_center": "ကမ်းမန်းစင်တာ",
    "sidebar.label.accounting": "စာရင်းကိုင်",
    "sidebar.label.search_journal_entries": "ဂျာနယ်မှတ်တမ်းများကို ရှာပါ",
    "sidebar.label.migrate_opening_balances":
      "အပေါ်ပိုင်းငွေပမာဏများကို လွှဲပြောင်းပါ",
    "sidebar.label.no_generator": "ဂျင်နရိတ်เตอร์ မရှိပါ",
    "sidebar.label.assets": "ပစ္စည်းများ",
    "sidebar.label.general": "ယေဘုယျ",
    "sidebar.label.ticketing": "လက်မှတ်စနစ်",
    "sidebar.label.plan_validation_rules": "အစီအစဉ် အတည်ပြုမှု စည်းမျဉ်းများ",
    "sidebar.label.sub_products": "အောက်ပိုင်း ထုတ်ကုန်များ",
    "sidebar.label.plan_prereqisites": "အစီအစဉ် မူလ တိုက်တွန်းချက်များ",
    "sidebar.label.subscription_master": "စာရင်းသွင်းခြင်း မာစတာ",
  },

  my: {
    "setup.label.group_ticketing": "အုပ်စုလက်မှတ်များ",
    "sidebar.label.payment_transactions": "ငွေပေးချေမှုများ",
    "sidebar.label.makerCheckerAction": "ဖန်တီးသူ စစ်ဆေးသူ",
    "sidebar.label.order_management": "အမှာစာများကို စီမံခန့်ခွဲမှု",
    "sidebar.label.dashboard": "ဒိုင်စက်စာမျက်နှာ",
    "sidebar.label.customers": "အဖွဲ့ဝင်များ",
    "sidebar.label.inventory": "အရေတွက်",
    "sidebar.label.tickets": "လက်မှတ်များ",
    "sidebar.label.business_entity": "စီးပွားရေးအနီးအနား",
    "sidebar.label.leads": "လွှာတင်ရန်",
    "sidebar.label.system": "စနစ်",
    "sidebar.label.users": "အသုံးပြုသူများ",
    "reports.label.manageRolesAndPermissions":
      "သုံးစွဲခြင်းနှင့် ခွင့်ပြုခြင်း စီမံခန့်ခွဲမှု",
    "reports.label.currencyMaster": "ငွေကြေးစီမံခန့်ခွဲမှု",
    "reports.label.currencyExchangeRates": "ငွေကြေး လွှဲပြောင်းမှု",
    "reports.label.configurations": "တပ်ဆင်များ",
    "reports.label.provisioningConfiguration": "ကုန်လွှဲခန့်ခွဲမှု",
    "reports.label.manageReports": "အစီရင်ခံစာများကုဒ်များ",
    "reports.label.manageCodes": "ကုဒ်များကုဒ်များ",
    "sidebar.label.setup": "ဆက်တင်မည်",
    "sidebar.label.reports": "အစီရင်ခံချက်များ",
    "sidebar.label.admin": "အက်မင်",
    "sidebar.label.bulk_uploads": "ကုန်လက်တင်မည်",
    "sidebar.label.scheduler_job": "အချိန်ဇယားကုမ္ပဏီ",
    "sidebar.label.online_payments": "ငွေပေးချေမှုများ",
    "sidebar.label.provisioning_status": "ပေးဆောင်းမှုအခြေအနေ",
    "sidebar.label.hooks": "ချုပ်များ (အဖွဲ့အစည်းလုံး)",
    "sidebar.label.maker_checker": "ဖန်တီးသူ စစ်ဆေးသူ",
    "sidebar.label.command_center": "အမိန့်စင်တာ",
    "sidebar.label.accounting": "စာရင်းကိုင်",
    "sidebar.label.search_journal_entries": "ဂျာနယ်မှတ်တမ်းများ ရှာဖွေပါ",
    "sidebar.label.migrate_opening_balances": "အစိုးရငွေပမာဏများ မိုက်ဂရိတ်ပါ",
    "sidebar.label.no_generator": "ဂျင်နရေးတာ မရှိပါ",
    "sidebar.label.assets": "ပစ္စည်းများ",
    "sidebar.label.general": "ယေဘုယျ",
    "sidebar.label.ticketing": "လက်မှတ်စနစ်",
    "sidebar.label.plan_validation_rules": "အစီအစဉ် အတည်ပြု စည်းမျဉ်းများ",
    "sidebar.label.sub_products": "အောက်ပိုင်း ထုတ်ကုန်များ",
    "sidebar.label.plan_prereqisites": "အစီအစဉ် အခြေခံ တိုက်တွန်းချက်များ",
    "sidebar.label.subscription_master": "စာရင်းသွင်းမှု မာစတာ",
  },

  vi: {
    "setup.label.group_ticketing": "Quản lý vé nhóm",
    "sidebar.label.payment_transactions": "Giao dịch thanh toán",
    "sidebar.label.makerCheckerAction": "Người tạo kiểm tra",
    "sidebar.label.order_management": "Quản lý Đơn hàng",
    "sidebar.label.dashboard": "Bảng điều khiển",
    "sidebar.label.customers": "Khách hàng",
    "sidebar.label.inventory": "Tồn kho",
    "sidebar.label.tickets": "Vé",
    "sidebar.label.business_entity": "Thực thể kinh doanh",
    "sidebar.label.leads": "Cơ hội",
    "sidebar.label.system": "Hệ thống",
    "sidebar.label.users": "Người dùng",
    "reports.label.manageRolesAndPermissions": "Quản lý Vai trò và Quyền",
    "reports.label.currencyMaster": "Chủ thể Tiền tệ",
    "reports.label.currencyExchangeRates": "Tỷ giá Hối đoái",
    "reports.label.configurations": "Cấu hình",
    "reports.label.provisioningConfiguration": "Cấu hình Cung cấp",
    "reports.label.manageReports": "Quản lý Báo cáo",
    "reports.label.manageCodes": "Quản lý Mã",
    "sidebar.label.setup": "Thiết lập",
    "sidebar.label.reports": "Báo cáo",
    "sidebar.label.admin": "Quản trị",
    "sidebar.label.bulk_uploads": "Tải lên hàng loạt",
    "sidebar.label.scheduler_job": "Công việc Lập lịch",
    "sidebar.label.online_payments": "Thanh toán trực tuyến",
    "sidebar.label.provisioning_status": "Tình trạng cung cấp",
    "sidebar.label.hooks": "Câu nối (Hành động Sự kiện)",
    "sidebar.label.maker_checker": "Trình kiểm tra trình tạo",
    "sidebar.label.command_center": "Trung Tâm Điều Khiển",
    "sidebar.label.accounting": "Kế Toán",
    "sidebar.label.search_journal_entries": "Tìm Kiếm Mục Sổ Nhật Ký",
    "sidebar.label.migrate_opening_balances": "Di Chuyển Số Dư Mở",
    "sidebar.label.no_generator": "Không Có Máy Phát",
    "sidebar.label.assets": "Tài Sản",
    "sidebar.label.general": "Chung",
    "sidebar.label.ticketing": "Hệ Thống Vé",
    "sidebar.label.plan_validation_rules": "Quy Tắc Xác Thực Kế Hoạch",
    "sidebar.label.sub_products": "Sản Phẩm Phụ",
    "sidebar.label.plan_prereqisites": "Yêu Cầu Tiên Quyết Của Kế Hoạch",
    "sidebar.label.subscription_master": "Danh Sách Đăng Ký",
  },
};
